import CardListHalf from './CardListHalf';

export default CardListHalf;
